import { Typography } from '@mui/material'
import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { useCallback } from 'react'

import { Drawer } from '#/components/Drawer'
import { getThi } from '#/components/FormatCell/Types/thi'
import Pin from '#/components/Maps/components/Pin'
import CEnvContent, { CEnvFooter } from '#/components/Maps/Markers/CEnv/drawer'
import { CEnv } from '#/components/Maps/Markers/types'
import Palette from '#/styles/Palette'

interface CenvMarkerProps {
  marker: CEnv
  setMarkerRef: (marker: google.maps.marker.AdvancedMarkerElement, slug: string) => void
}

export function CEnvMarker({ marker, setMarkerRef }: CenvMarkerProps) {
  const style =
    marker.show === 'thi'
      ? getThi(marker.thi as number).style
      : {
          backgroundColor: Palette.gray.self[300],
          color: Palette.gray.self[800],
        }

  const ref = useCallback(
    (ref: google.maps.marker.AdvancedMarkerElement) => setMarkerRef(ref, marker.id),
    [setMarkerRef, marker.id],
  )

  return (
    <AdvancedMarker ref={ref} position={marker} onClick={() => cenvDrawerOpen(marker)}>
      <Pin
        icon={
          <Typography sx={{ fontSize: 14, fontWeight: 600, px: 1 }}>
            {marker[marker.show] ?? '-'}
          </Typography>
        }
        {...style}
      />
    </AdvancedMarker>
  )
}

export const cenvDrawerOpen = (marker: CenvMarkerProps['marker']) =>
  Drawer.open({
    content: <CEnvContent marker={marker} />,
    footer: <CEnvFooter marker={marker} />,
  })
